import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-15de9d22"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "change-password"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-tips"
}, "为了您的账户安全，需要进行手机验证", -1));
const _hoisted_3 = {
  class: "test-content"
};
const _hoisted_4 = {
  class: "slideWrap"
};
const _hoisted_5 = {
  class: "verification-code"
};
import MainButton from '@/components/MainButton/MainButton.vue';
import { ref, reactive, onMounted, getCurrentInstance, watch } from 'vue';
import { sendSMSMessage, modifyPhoneNum } from '@/api/phone/phone-change';
import { getscene } from '@/api/phone/password-change';
import { useRoute, useRouter } from 'vue-router';
import { loginOut } from '@/utils/navitiveApi/common';
import { showDialog } from "vant";
import { showSuccessToast } from "vant";
import { showFailToast } from "vant";
export default /*#__PURE__*/_defineComponent({
  __name: 'Changephone',
  setup(__props) {
    var _getCurrentInstance$p, _getCurrentInstance;
    const disabled = ref(true);
    const scenecode = ref('');
    const appkeycode = ref('');
    const reloadbtn = ref(false);
    const route = useRoute();
    const router = useRouter();
    const {
      $alert,
      $loading
    } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : {};
    const countDownFinished = ref(false);
    const downFinished = ref(false);
    const countDown = ref(null);
    const mescode = ref(null);
    const smsCode = ref(null);
    const tel = ref(null);
    const show = ref(false);
    const request = reactive({
      phoneNo: tel,
      channel: '99',
      smsCode: '',
      sessionId: '',
      sig: '',
      vToken: ''
    });
    //监听信息是否为空，展示按钮高亮
    watch(() => [request.phoneNo, request.smsCode], ([newphoneNo, newsmsCode], [oldphoneNo, oldsmsCode]) => {
      if (newphoneNo !== '' && newsmsCode !== '') {
        disabled.value = false;
      } else {
        disabled.value = true;
      }
    });
    const onCountDownfinish = () => {
      reloadbtn.value = !reloadbtn.value;
      // downFinished.value = false
      // countDownFinished.value = false
      // countDown.value.reset()
      // mescode.value.innerText = '获取验证码'
    };

    const sendCode = async () => {
      $loading.openLoading();
      const {
        phoneNo,
        channel
      } = request;
      const req = {
        phoneNo,
        channel,
        verificationSessionId: request.sessionId,
        verificationSig: request.sig,
        verificationToken: request.vToken
      };
      try {
        const {
          code,
          data,
          message
        } = await sendSMSMessage(req);
        if (code !== 9000) {
          $loading.closeLoading();
          onCountDownfinish();
          $alert({
            message
          });
          return;
        } else {
          downFinished.value = true;
          // countDownFinished.value = false
          // countDown.value.reset()
          // mescode.value.innerText = ''
          $loading.closeLoading();
          $alert({
            message: data
          });
        }
      } catch (e) {
        console.log(e);
      }
    };
    const onClickNext = async () => {
      $loading.openLoading();
      const {
        phoneNo,
        smsCode
      } = request;
      const req = {
        phoneNum: phoneNo,
        phoneCode: smsCode
      };
      console.log('phoneNum', phoneNo, 'phoneCode', smsCode);
      try {
        const {
          code,
          data,
          message
        } = await modifyPhoneNum(req);
        if (code !== 9000) {
          $loading.closeLoading();
          reloadbtn.value = !reloadbtn.value; //不通过时重置滑块
          $alert({
            message
          });
          return;
        } else {
          $loading.closeLoading();
          showDialog({
            message: data + '，请重新登录',
            showConfirmButton: false
          });
          setTimeout(() => {
            loginOut();
          }, 1000);
        }
      } catch (e) {
        console.log(e);
      }
    };
    const slidetosuccess = val => {
      console.log('slidetosuccess', val);
      showSuccessToast('验证成功');
      // sendCode()
      countDownFinished.value = true;
      request.sessionId = val.sessionId;
      request.sig = val.sig;
      request.vToken = val.token;
      // 滑块成功直接发验证码
      console.info('滑块成功直接发验证码');
      sendCode();
    };
    const slidetofail = () => {
      showFailToast('验证失败');
      reloadbtn.value = !reloadbtn.value;
    };
    const queryscene = async () => {
      const params = {
        partition: 'verification',
        key: 'sms'
      };
      const {
        code,
        message,
        data
      } = await getscene(params);
      console.log('phonequeryscene', code, message, data);
      if (code === 9000) {
        show.value = true;
        scenecode.value = data.value.scene;
        appkeycode.value = data.value.appkey;
      } else {
        showFailToast(message);
      }
    };
    onMounted(() => {
      queryscene();
    });
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_noCaptcha = _resolveComponent("noCaptcha");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: tel.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tel.value = $event),
          type: "tel",
          label: "手机号",
          placeholder: "请输入新手机号"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _withDirectives(_createElementVNode("div", _hoisted_4, [_createVNode(_component_noCaptcha, {
        id: "changePhone",
        scene: scenecode.value,
        appkey: appkeycode.value,
        onSlideSuccessCallback: slidetosuccess,
        onSlideErrorCallback: slidetofail,
        reload: reloadbtn.value
      }, null, 8, ["scene", "appkey", "reload"])], 512), [[_vShow, show.value]]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: request.smsCode,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => request.smsCode = $event),
          label: "验证码",
          placeholder: "请输入验证码",
          clearable: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      })]), _createVNode(MainButton, {
        disabled: disabled.value,
        onClick: onClickNext
      }, {
        default: _withCtx(() => [_createTextVNode("确定")]),
        _: 1
      }, 8, ["disabled"])])]);
    };
  }
});